export const rolesData = {
  nasabah: {
    title: 'Nasabah',
    description: 'Nasabah merupakan pengguna yang menyetor sampah dan memiliki saldo digital berdasarkan nilai sampah yang disetorkan.',
    features: [
      {
        name: 'Registrasi Akun',
        description: 'Nasabah dapat melakukan pendaftaran akun untuk mengakses seluruh layanan aplikasi.',
      },
      {
        name: 'Pengajuan Penarikan Saldo',
        description: 'Nasabah dapat mengajukan pencairan saldo yang dimiliki ke metode penarikan yang tersedia.',
      },
      {
        name: 'Penambahan & Pengelolaan Metode Penarikan Dana',
        description: 'Nasabah dapat menambahkan, mengubah, dan mengelola metode penarikan seperti rekening bank atau e-wallet.',
      },
    ],
  },
  admin: {
    title: 'Admin',
    description: 'Admin memiliki akses penuh untuk mengelola sistem, pengguna, transaksi, dan kebijakan operasional aplikasi.',
    features: [
      {
        name: 'Penambahan & Pengelolaan Petugas',
        description: 'Mengelola data petugas yang bertanggung jawab di lapangan.',
      },
      {
        name: 'Top Up Saldo Sistem',
        description: 'Menambahkan saldo ke dalam sistem untuk mendukung transaksi dan operasional.',
      },
      {
        name: 'Alokasi Dana untuk Petugas',
        description: 'Mengatur distribusi dana operasional kepada petugas.',
      },
      {
        name: 'Penambahan Collation Center',
        description: 'Mengelola pusat pengumpulan dan pengolahan sampah.',
      },
      {
        name: 'Penugasan Petugas ke Collation Center',
        description: 'Menentukan petugas yang bertanggung jawab pada setiap lokasi.',
      },
      {
        name: 'Persetujuan (ACC) Penarikan Dana',
        description: 'Melakukan verifikasi dan persetujuan pengajuan penarikan saldo.',
      },
      {
        name: 'Pencatatan Penerimaan Sampah dari Lapak',
        description: 'Mencatat jumlah dan jenis sampah yang diterima.',
      },
      {
        name: 'Proses Pembayaran Lapak',
        description: 'Mengelola pembayaran kepada lapak berdasarkan transaksi yang terjadi.',
      },
      {
        name: 'Penyesuaian Harga Sampah',
        description: 'Menentukan dan memperbarui harga sampah untuk lapak dan nasabah.',
      },
      {
        name: 'Informasi & Pengelolaan Data Lapak',
        description: 'Melihat dan mengelola data lapak secara terpusat.',
      },
    ],
  },
  petugas: {
    title: 'Petugas',
    description: 'Petugas bertanggung jawab dalam operasional lapangan dan pencatatan transaksi sampah.',
    features: [
      {
        name: 'Login Petugas',
        description: 'Akses sistem menggunakan akun resmi petugas.',
      },
      {
        name: 'Pencatatan Setoran Sampah Nasabah',
        description: 'Mencatat transaksi setoran sampah dari nasabah.',
      },
      {
        name: 'Penambahan Data Rekanan',
        description: 'Menambahkan pihak rekanan yang bekerja sama.',
      },
      {
        name: 'Penambahan & Pengelolaan Lapak',
        description: 'Mengelola lapak yang berada di bawah tanggung jawab petugas.',
      },
      {
        name: 'Pengiriman Sampah dari Lapak ke Customer',
        description: 'Mengatur distribusi sampah dari lapak ke pihak pembeli.',
      },
      {
        name: 'Pengiriman Sampah Milik Nasabah',
        description: 'Mencatat pengiriman sampah yang berasal langsung dari nasabah.',
      },
    ],
  },
  rekanan: {
    title: 'Rekanan',
    description: 'Rekanan merupakan pihak mitra yang terlibat dalam transaksi dan distribusi sampah.',
    features: [
      {
        name: 'Pengajuan Penarikan Saldo',
        description: 'Rekanan dapat mengajukan pencairan saldo hasil transaksi.',
      },
      {
        name: 'Penambahan & Pengelolaan Metode Penarikan Dana',
        description: 'Mengelola metode pencairan dana rekanan.',
      },
    ],
  },
};